import types from "../actions/actionTypes";
import initialState from "./initialState";

export default function projectItemIdsNeedingUpdateReducer(state = initialState.projectItemIdsNeedingUpdate, action) {


    const mergeIdInMultiple = (projectItemIds, ids) => {
        return projectItemIds.filter(p => !ids.includes(p))
            .concat(ids);
    }

    const mergeIdIn = (projectItemIds, id) => {
        const ids = [id];
        return mergeIdInMultiple(projectItemIds, ids);    
    }

    switch (action.type) {
        case types.LOAD_PROJECTITEM_SUCCESS:
            return state.filter(s => s !== action.projectItem.id);
        case types.UPDATED_PROJECTITEM_INCOMING:
           return mergeIdIn(state, action.payload.id);
        case types.DELETED_PROJECTITEMNOTE:
        case types.UPDATED_PROJECTITEMNOTE_SUCCESS: 
            return mergeIdIn(state, action.note.itemId);
        case types.UPDATED_PROJECTITEMMILESTONE_SUCCESS:
        case types.DELETED_PROJECTITEMMILESTONE:
            return mergeIdIn(state, action.projectItemMilestone.itemId);
        case types.UPDATED_PROJECTITEMACTIVITY_SUCCESS:
        case types.DELETED_PROJECTITEMACTIVITY:         
            return mergeIdIn(state, action.projectItemActivity.itemId);
        case types.CREATED_INVOICE_SUCCESS:           
            return mergeIdInMultiple(state, action.invoice.updatedItemIds);
        case types.DELETED_INVOICE:
            return mergeIdInMultiple(state, action.project.itemIds);   
        case types.DELETED_PROJECTITEMNOTE_INCOMING:
        case types.UPDATED_PROJECTITEMNOTE_INCOMING:
        case types.UPDATED_PROJECTITEMMILESTONE_INCOMING:
        case types.DELETED_PROJECTITEMMILESTONE_INCOMING:
        case types.UPDATED_PROJECTITEMACTIVITY_INCOMING:
        case types.DELETED_PROJECTITEMACTIVITY_INCOMING:
            return mergeIdIn(state, action.payload.itemId);
        case types.CREATED_INVOICE_INCOMING:
        case types.DELETED_INVOICE_INCOMING:
            return mergeIdInMultiple(state, action.payload.itemIds);
        default:
            return state;
    }
}